import { useMemo } from 'react';
import { maskCep, maskCpfCnpj } from '@ibk/shared-utils';
export function useChargesPayerForm() {
    const formatDocument = (value) => {
        return maskCpfCnpj(value);
    };
    const formatCep = (value) => {
        return maskCep(value);
    };
    const formatNumber = (value) => {
        return value.replace(/\D/g, '');
    };
    const getDocumentType = (document) => {
        const cleanDocument = document.replace(/\D/g, '');
        if (cleanDocument.length === 11) {
            return 'cpf';
        }
        else if (cleanDocument.length === 14) {
            return 'cnpj';
        }
        return null;
    };
    const isDocumentComplete = (document) => {
        const cleanDocument = document.replace(/\D/g, '');
        return cleanDocument.length === 11 || cleanDocument.length === 14;
    };
    const isCepComplete = (cep) => {
        const cleanCep = cep.replace(/\D/g, '');
        return cleanCep.length === 8;
    };
    return useMemo(() => ({
        formatDocument,
        formatCep,
        formatNumber,
        getDocumentType,
        isDocumentComplete,
        isCepComplete,
    }), []);
}
